import React, { useContext } from 'react';
import { useTranslation } from "react-i18next";
import { Badge, Container, Nav, Navbar } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faUser, faSignOut, faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';

import LotCountContext from './Contexts/LotCountContext';
import { client as publicClientApplication, signOut } from './Utilities/AuthUtils';
import PrivilegeContext from './Contexts/PrivilegeContext';
import { usePollData } from './Utilities/usePollData';
import { Environment, useEnvironment } from './Utilities/useEnvironment';

import logo from '../images/cmn-exxonmobil-logo.gif';
import './NavMenu.css';

export default function NavMenu() {

    const { t } = useTranslation();

    const { updateCounters, ungradedLotCount, readyToReviewCount, readyToGradeCount } = useContext(LotCountContext);
    const { admin, canConfigure } = useContext(PrivilegeContext);
    const environment = useEnvironment();

    // Show Dev and Acc in the application title but not Local or Prd
    const displayEnvironment = environment !== Environment.Local && environment !== Environment.Prd && environment;

    const account = publicClientApplication.getAllAccounts()[0];

    // update lot counters at interval
    usePollData(updateCounters, 60 * 1000);

    return (
        <header>
            <Navbar expand="lg" bg="white" variant="light" className="border-bottom box-shadow mb-3">
                <Container fluid>
                    <Navbar.Brand as={Link} to="/lots" >
                        <img src={logo}
                            alt="ExxonMobil"
                            width="150"
                            className="d-inline-block align-middle me-3" />
                        <strong className="d-none d-xxl-inline-block">{t("Application.Title")} {displayEnvironment}</strong>
                        <strong className="d-xxl-none d-inline">{t("Application.Abbreviation")}</strong>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav.Link as={NavLink} to="/lots" end>
                            <Navbar.Text className="text-dark">{t("Navigation.AllLots")}</Navbar.Text>
                            {ungradedLotCount > 0 &&
                                <Badge pill bg="danger" className="ms-2 d-lg-none d-xl-inline">{ungradedLotCount}</Badge>
                            }
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/lots/ReadyToReview" >
                            <Navbar.Text className="text-dark">{t("Navigation.AwaitingReview")}</Navbar.Text>
                            {readyToReviewCount > 0 &&
                                <Badge pill bg="danger" className="ms-2 d-lg-none d-xl-inline">{readyToReviewCount}</Badge>
                            }
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/lots/ReadyToGrade" >
                            <Navbar.Text className="text-dark">{t("Navigation.AwaitingGrading")}</Navbar.Text>
                            {readyToGradeCount > 0 &&
                                <Badge pill bg="danger" className="ms-2 d-lg-none d-xl-inline">{readyToGradeCount}</Badge>
                            }
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/reporting" >
                            <Navbar.Text className="text-dark">{t("Navigation.Reporting")}</Navbar.Text>
                        </Nav.Link>
                    </Navbar.Collapse>
                    <Navbar.Collapse className="justify-content-end">
                        {canConfigure &&
                            <Nav.Link as={NavLink} to="config">
                                <FontAwesomeIcon icon={faCog} />
                                <Navbar.Text className="ms-2 text-dark d-lg-none d-xl-inline">{t("Navigation.Configuration")}</Navbar.Text>
                            </Nav.Link>
                        }
                        {admin &&
                            <Nav.Link as={NavLink} to="admin">
                                <FontAwesomeIcon icon={faScrewdriverWrench} />
                                <Navbar.Text className="ms-2 text-dark d-lg-none d-xl-inline">{t("Navigation.Admin")}</Navbar.Text>
                            </Nav.Link>
                        }
                        <Nav.Link as={NavLink} to="user">
                            <FontAwesomeIcon icon={faUser} />
                            <Navbar.Text className="ms-2 text-dark d-lg-none d-xl-inline">{account && account.name}</Navbar.Text>
                        </Nav.Link>
                        <Nav.Link onClick={signOut}>
                            <FontAwesomeIcon icon={faSignOut} />
                            <Navbar.Text className="ms-2 text-dark d-lg-none d-xl-inline">
                                {t("Navigation.SignOut")}
                            </Navbar.Text>
                        </Nav.Link>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
}